// extracted by mini-css-extract-plugin
export default {"container":"CourseReports_container__rYwPv","section":"CourseReports_section__FBaIy","sectionInner":"CourseReports_sectionInner__uK+8i"};